//
//
//
//
//
//
//
//
//
//
//

import getRecommendConsultant from '@/common/consultant/recommend_consultant'
import Card from './_card'
import { openChat } from '@/data/im'
export default {
    props: {
        items: Array,
        building_id: Number,
    },
    components: {
        Card
    },
    methods: {
        async onConsult () {
            const params = {
                building_id: this.building_id
            }
            const data = await getRecommendConsultant({
                ...params,
                scene: 'purchase_qualification',
            })
            if (data.id) {
                openChat(data.id, {
                    ...params,
                    log_name: '楼盘价值分析报告-咨询购房资格',
                    from: '查询购房资格'
                })
            } else {
                wx.navigateTo({
                    url: `/consultants/filter/main?id=${this.building_id}`
                })
            }
        },
    }
}
